export default defineAppConfig({
    ui: {
      colorMode: false,
      colors: {
        primary: 'blue',
        
        secondary: 'zinc'
      },
      button: {
        slots: {
          base: 'rounded-sm cursor-pointer '
        }
      }
    }
  })